module.exports = function() {
  return new Worker(__webpack_public_path__ + "5b0187dc5687a73286a6.worker.js");
};